import { useEffect, useState } from "react"
import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import CardActionArea from "@mui/material/CardActionArea"
import Chip from "@mui/material/Chip"
import Skeleton from "@mui/material/Skeleton"
import Typography from "@mui/material/Typography"
import type { Ape } from "./useOwnedApes"
import { useDiscovered } from "./useOwnedApes"
import { ApeImage, fetchArweaveApe } from "./ApeTraits"
import Carousel from "./Carousel"
import collection from "./data/collection.json"

const top = collection.top as [number: number, dna: string, tx: string][]

const TopApes = () => {
	const [apes, setApes] = useState<(Ape | null)[]>()
	const discovered = useDiscovered()

	useEffect(() => {
		// One failed Arweave fetch shouldn't hide the other nine
		Promise.all(top.map(([n, dna, tx]) => fetchArweaveApe(n, dna, tx).catch(() => null))).then(setApes)
	}, [])

	return (
		<Carousel label="Top 10 rarest apes">
			{top.map(([number, dna], i) => {
				const ape = apes?.[i]
				// Hidden until minted; also while loading or if the lookup fails, so nothing leaks early
				const found = !!discovered?.has(number)
				return (
					<Card key={dna}>
						<CardActionArea component="a" href={found ? `/${dna}` : undefined} disabled={!found}>
							<Box sx={{ position: "relative" }}>
								{ape
									? <ApeImage ape={ape} hidden={!found} />
									: <Skeleton variant="rectangular" sx={{ aspectRatio: "1", height: "auto" }} />}
								<Chip label={`#${i + 1}`} sx={{ position: "absolute", top: 12, left: 12, bgcolor: "#fff", fontWeight: 700 }} />
							</Box>
							<Box sx={{ p: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
								<Typography sx={{ fontWeight: 700 }}>Pastel #{number}</Typography>
								{discovered && (
									<Chip size="small" label={found ? "Discovered" : "Undiscovered"}
										color={found ? "primary" : "default"} variant={found ? "filled" : "outlined"} />
								)}
							</Box>
						</CardActionArea>
					</Card>
				)
			})}
		</Carousel>
	)
}

export default TopApes
